<template>
    <div>
        <b-modal 
            no-stacking
            v-model="notiShop.show"
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer  
            @hidden="(notiShop.router) ? goToPopShop(): $emit('close')"     
        >
            <div class="container-fluid pb-3">
                <div class="row mb-1 text-center">
                    <div class="col-12 mb-3">
                        <img :src="detailNoti.icon" alt="Notification" />
                        <h2 class="pt-1">{{detailNoti.header}}</h2>
                        <h3 class="text-muted">{{detailNoti.textDetail}}</h3>
                        <h3>{{detailNoti.textEnd}}</h3>
                        <a href="https://business.shippop.com" v-if="detailNoti.colorButton" :class="`mt-4 btn btn-${detailNoti.colorButton} btn-icon`" target="_blank">
                            แจ้งชำระเงิน
                        </a>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import moment from "moment";
export default {
    name: "ModalNotification" ,
    props: {
        notiShop: Object,
    },
    data() {
        return {
        }
    },
    methods:{
        goToPopShop(){
            if(this.notiShop.role === "superadmin" || this.notiShop.role === "shippop"){
                this.$router.push("/transports");
            }else{
                this.$router.push("/");
            }
        }
    },
    computed: {
        detailNoti(){
            if(this.notiShop.type == 'LOCK'){
                if(this.notiShop.created_by == 'superadmin' && this.notiShop.role != 'superadmin'){
                    return {
                        icon: require('../../assets/images/icon-noti-lock.svg'),
                        header: "ระบบไม่สามารถใช้งานได้",
                        textDetail: "ขออภัยในความไม่สะดวก ระบบถูกระงับการใช้งานชั่วคราว",
                        textEnd: "กรุณาติดต่อผู้ดูแลระบบของท่าน",
                        colorButton: ""
                    }
                }else{
                    return {
                        icon: require('../../assets/images/icon-noti-lock.svg'),
                        header: "ระบบระงับการใช้งานชั่วคราว",
                        textDetail: "เนื่องจากคุณมียอดค้างชำระเกินเวลาที่กำหนด",
                        textEnd: "",
                        colorButton: "danger"
                    }
                }
            }else if(this.notiShop.type == 'DEBT'){
                moment.locale('th')
                let date = moment(this.notiShop.date_noti , "YYYY-MM-DD").startOf('isoWeek').add(1, 'week').format('LLLL').replace("เวลา 0:00", "");
                return {
                    icon: require('../../assets/images/icon-noti.svg'),
                    header: "คุณมียอดค้างชำระค้างอยู่",
                    textDetail: "",
                    textEnd: `กรุณาทำการชำระเงินภายใน${date} ก่อน 13:00 น.`,
                    colorButton: 'primary'
                }
            }else{
                return{
                    icon: "",
                    header: "",
                    textDetail: "",
                    textEnd: "",
                    colorButton: "",
                }
            }
        }
    }
}
</script>
<style scoped>

</style>